type LoadingProps = {
  className?: string;
};

const Loading: React.FC<LoadingProps> = ({ className }) => {
  return <div className={className}>Loading</div>;
};

export default Loading;
